export interface CustomerCustomFilters {
	search?: string;
}

export interface CustomerFilters extends CustomerCustomFilters {
	page: number;
	size: number;
	sort?: string | string[] | undefined;
}

export enum CustomerTabs {
	INDIVIDUAL = "individual",
	LEGAL = "legal"
}
